import React, { useState } from "react";
import "./AdditionalProductsBox.css";
import Button from "./Button";
import CheckBox from "./CheckBox";
import { performAdditionalProductsRequest } from "../utils/NetworkUtils";
import AdditionalResult from "./AdditionalResult";
import result_call_divert from "../assets/result_call_divert.svg";
import result_sim_swap from "../assets/result_sim_swap.svg";
import result_number_recycle from "../assets/result_number_recycle.svg";
import LoadingSpinner from "../components/LoadingSpinnerBox";

function AdditionalProductsBox({ MSISDN, selectedCountryConfig, additionalProducts, clearVerifiedTimeout, showError, startConnectionTimeout, clearConnectionTimeout }) {
  console.log("additionalProducts: " + additionalProducts);

  const [checkedState, setCheckedState] = useState(new Array(additionalProducts.length).fill(true));
  const [response, setResponse] = useState(false);
  const [additionalResults, setAdditionalResults] = useState(null);
  const [disabledButton, setDisabledButton] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  function onAdditionalProductsClick() {
    startConnectionTimeout();
    setShowLoading(true);
    let selectedScopes = [];
    checkedState.forEach((state, index) => {
      if (state) {
        selectedScopes.push(additionalProducts[index]);
      }
    });

    console.log(selectedScopes);
    performAdditionalProductsRequest(additionalProductsRequestCallBack, MSISDN, selectedCountryConfig, selectedScopes);
  }

  function getCheckBoxTitle(scope) {
    switch (scope) {
      case "mc_vf_sim_change":
        return "SIM Change";

      case "mc_vf_number_recycle":
        return "Number Recycle";

      case "mc_vf_call_divert":
        return "Call Divert";
      default:
        break;
    }
  }

  function getCheckBoxDescription(scope) {
    switch (scope) {
      case "mc_vf_sim_change":
        return "Determine if a SIM change has taken place";

      case "mc_vf_number_recycle":
        return "Identify if the number had a previous owner";

      case "mc_vf_call_divert":
        return "Verify if call diverts are set";
      default:
        break;
    }
  }

  function handleOnChange(position) {
    console.log("handleOnChange for " + additionalProducts[position]);
    const updatedCheckedState = checkedState.map((state, index) => (index === position ? !state : state));
    setCheckedState(updatedCheckedState);

    setDisabledButton(updatedCheckedState.every((state) => state === false));
  }

  function additionalProductsRequestCallBack(json, error) {
    clearVerifiedTimeout();
    setShowLoading(false);
    clearConnectionTimeout();
    if (json) {
      console.log("additionalProductsRequestCallBack response: " + JSON.stringify(json, null, 2));
      setResponse(true);
      var additionalResultsList = [];
      json.additionalProducts.forEach((product, index) => {
        var image;
        var title;
        var descr;
        var value;
        switch (product.scope) {
          case "mc_vf_sim_change":
            image = result_sim_swap;
            title = "Sim change date";
            if (product.status === 200 && product.attributes.sim_change !== null) {
              descr = "";
              value = product.attributes.sim_change.substring(0, 10);
            } else {
              descr = "UNKNOWN";
              value = "";
            }
            break;
          case "mc_vf_number_recycle":
            image = result_number_recycle;
            title = "Number Recycled?";
            if (product.status === 200 && product.attributes.reuse !== null) {
              descr = (product.attributes.reuse === true ? "YES" : "NO") + (product.attributes.is_recycled ? ", on " : "");
              value = product.attributes.is_recycled || "";
            } else {
              descr = "UNKNOWN";
              value = "";
            }
            break;
          case "mc_vf_call_divert":
            image = result_call_divert;
            title = "Call diverted?";
            if (product.status === 200 && product.attributes.is_unconditional_call_divert_active !== null) {
              descr = product.attributes.is_unconditional_call_divert_active ? "YES" : "NO";
            } else {
              descr = "UNKNOWN";
            }
            value = "";
            break;

          default:
            image = result_sim_swap;
            title = product.scope + " Unsupported";
            descr = "Unsupported";
            value = "";
            break;
        }

        additionalResultsList.push(<AdditionalResult key={product.scope} image={image} title={title} description={descr} value={value} divider={index !== json.additionalProducts.length - 1} />);
      });

      setAdditionalResults(additionalResultsList);
    }
    if (error) {
      console.log("An error occurred performing the request: " + error);
      showError();
    }
  }

  var checkBoxList = additionalProducts.map((scope, index) => (
    <CheckBox
      key={scope}
      title={getCheckBoxTitle(scope)}
      description={getCheckBoxDescription(scope)}
      checked={checkedState[index]}
      onChange={() => handleOnChange(index)}
      divider={index === additionalProducts.length - 1}
    />
  ));

  return additionalProducts.length === 0 ? null : (
    <div className={"additional-product-box"}>
      {response ? (
        <div className="response">{additionalResults}</div>
      ) : (
        <div className="dynamicContent">
          {showLoading ? <LoadingSpinner /> : ""}
          {!showLoading ?
            <div className="request">
              <div className="additional-product-title">Which Vodafone services would you like to try next?</div>
              <div className="selection">{checkBoxList}</div>
              <Button onClick={onAdditionalProductsClick} text="Go" btnStyle="alt1" disabled={disabledButton} />
            </div> : ""
          }
        </div>
      )}
    </div>
  );
}

export default React.memo(AdditionalProductsBox);
